import {
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
} from '@angular/core';
import { UnRx } from '@pebula/utils';
import { CollectionContainerDirective } from './collection-container.directive';

@UnRx() //suppression de tous les observables du compo
@Directive({
  selector: '[collectionItem]',
  exportAs: 'wizCollItem',
})
/** un élément d'un compo de type collection (list / grid / tree) */
export class CollectionItemDirective {
  // liaison sur la classe de rendu du focus
  @HostBinding('class.is-focused-item')
  get isFocused() {
    // console.log('idx', this.itemIndex, this._container.currentFocusIndex);
    return this.itemIndex === this._container.currentFocusIndex;
    // return this.elementRef.nativeElement === document.activeElement;
  }

  /**
   * mise en place de l'écouteur mouseDown pour initialisation éventuelle
   * du drag'n'drop par le container parent
   */
  @HostListener('mousedown', ['$event'])
  onMouseDown(_: Event) {
    if (this._container) {
      this._container.itemMouseDown(this);
    }
  }

  /** sélection de l'item sur click */
  @HostListener('click', ['$event'])
  onClick(_: Event) {
    this.elementRef.nativeElement.focus();
    this._container.clicked.next(this._itemIndex); // Transimission du "clicked" sur le parent
  }

  /** double click sur l'item */
  @HostListener('dblclick', ['$event'])
  onDbClick(_: Event) {
    this.elementRef.nativeElement.focus();
    this._container.dbClicked.next(this._itemIndex); // Transimission du "dbClicked" sur le parent
  }

  constructor(public elementRef: ElementRef) {}

  /** un item (l'objet métier) de la collection du virtualScroll */
  @Input() public item: any;

  /**
   * pose de l'index
   */
  @Input() public set itemIndex(pValue: number) {
    if ( this._itemIndex !== undefined && this._itemIndex === this._container.currentFocusIndex ) {
      this._container.currentFocusIndex = pValue;
    }
    this._itemIndex = pValue;
  }

  public get itemIndex(): number {
    return this._itemIndex;
  }

  private _itemIndex: number;

  /** le composant parent  */
  @Input()
  set container(pValue: CollectionContainerDirective) {
    this._container = pValue;
    if (!!this._container) {
      // Liaison au composant sélectionné du parent pour prise de focus
      this._container.currentFocusObs.subscribe((idx) => {
        if (idx === this._itemIndex) {
          this.focus();
        }
      });
    }
  }

  private _container: CollectionContainerDirective;

  /** assignaton du focus */
  private focus(): void {
    // console.log('collection set focus', this.isFocused);
    if(this.isFocused) { // LMA RM8194, perte de focus sur les filtres : prise de focus seulement si le container à le focus
      // console.log('collection has focus', this._itemIndex);
      this.elementRef.nativeElement.focus();
    }
    

  }
}
